//IDIOMAS
import VueI18n from 'vue-i18n'
import messages from '../translations';
import Vue from 'vue'

import {brandDetector} from '@/brands';

let brandStyles = brandDetector();
const langFromQuery = new URLSearchParams(window.location.search).get('lang');
const validLangFromQuery = Object.keys(messages).includes(langFromQuery) ? langFromQuery : null;

let lang;

if(validLangFromQuery){
  lang = validLangFromQuery;
}else if(window.localStorage.getItem('_idIdiomaPreferido')){
  lang = window.localStorage.getItem('_idIdiomaPreferido');
}else if(window.localStorage.getItem('language')){
  lang = window.localStorage.getItem('language');
}else if(brandStyles.languagebydefault && !lang){
  lang = brandStyles.languagebydefault;
}else{
  lang = "es";
}




Vue.use(VueI18n);


const i18n = new VueI18n({
	locale: lang,
	messages,
});
//.IDIOMAS

export default i18n;


// WEBPACK FOOTER //
// ./src/i18n/index.js